import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil, flatMap, tap } from 'rxjs/operators';
import { GroupsService } from '../services/groups.service';
import { Subject, forkJoin, of } from 'rxjs';
import { UserService } from '../services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    template: ``
})
export class JoinGroupComponent implements OnInit, OnDestroy {
    private cleanupTime = new Subject<void>();
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private snackbar: MatSnackBar,
                private groupService: GroupsService,
                private userService: UserService) {}
    
    ngOnInit(): void {
        this.route.parent.params
        .pipe(
            takeUntil(this.cleanupTime),
            flatMap(params => forkJoin(
                of(params.groupId),
                this.groupService.addUser(params.groupId, this.userService.getCurrentUser().id))
            ),
            tap(() => this.snackbar.open('Subscribed to group', 'OK',  { duration: 5000 }))
        )
        .subscribe(([groupId]) => this.router.navigate(['/browse', 'groups', groupId, 'details']));
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
    }
}